import React, { FC, Fragment, useMemo } from "react";
import { IScheme } from "@cayo/shared/api/types/schema";
import { StretchedContainer } from "@cayo/shared/components/CommonLayout";
import { schemeParts } from "@cayo/shared/components/schemes/schemeParts";
import ODataScheme from "./ODataScheme";
import SchemeLoader from "./SchemeLoader";
import { useNavSelectedSchemeId } from "../Nav/nav-hooks";

const PageContent: FC<IScheme> = () => {
  const navSchemeId = useNavSelectedSchemeId();
  const dashboardId = schemeParts.ids.dashboard;

  const dashboardInfo = useMemo(() => {
    return {
      isDashboard: navSchemeId.toLowerCase().endsWith(dashboardId),
      dashboardSchemeId: navSchemeId.split("/").reverse().join("/"),
    };
  }, [navSchemeId]);

  if (!navSchemeId) {
    return <Fragment />;
  }

  const { isDashboard } = dashboardInfo;

  return (
    <StretchedContainer isNaturalLightBg={isDashboard}>
      {isDashboard && <SchemeLoader schemePath={dashboardInfo.dashboardSchemeId} />}
      {!isDashboard && (
        <ODataScheme
          schemePath={navSchemeId}
          key={navSchemeId}
          isMainView
          restorePropPanel={true}
        />
      )}
      {/* {isDashboard && <GaugeChart />} */}
    </StretchedContainer>
  );
};

export default PageContent;
